export class OrderAccess {
  constructor(access = {}) {
    this.id = access.id ?? '';
    this.productId = access.productId ?? '';
    this.productName = access.productName ?? '';
    this.itemId = access.itemId ?? '';
    this.itemName = access.itemName ?? '';
    this.horizontal = access.horizontal ?? '';
    this.isActive = access.isActive ?? false;
    this.startsAt = access.startsAt ?? null;
    this.expiresAt = access.expiresAt ?? null;
    this.accumulatedExpiresAt = access.accumulatedExpiresAt ?? null;
  }

  get effectiveExpiresAt() {
    return this.accumulatedExpiresAt ?? this.expiresAt;
  }

  get statusLabel() {
    return this.isActive ? 'Ativo' : 'Expirado';
  }

  static fromJson(json) {
    return new OrderAccess({
      id: json.id ?? '',
      productId: json.product_id ?? '',
      productName: json.product_name ?? '',
      itemId: json.item_id ?? '',
      itemName: json.item_name ?? '',
      horizontal: json.horizontal ?? '',
      isActive: json.is_active ?? false,
      startsAt: json.starts_at ?? null,
      expiresAt: json.expires_at ?? null,
      accumulatedExpiresAt: json.accumulated_expires_at ?? null,
    });
  }
}
